import { useUser } from "@/composables/user";
import { Layout } from "@/router";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login";
import { useRoute } from "vue-router";

export function useLayout() {
  const layout = ref<Layout>();

  const route = useRoute();
  const { user } = useUser();

  const recomputeLayout = async () => {
    // Prevent flickering when user is not logged in yet
    await checkUserOnInitialPageLoad();

    // Initial page load
    if (route.name === undefined) {
      return undefined;
    }

    layout.value = route.meta.layout ?? Layout.Default;
  };

  watch(route, recomputeLayout);
  watch(user, recomputeLayout);

  return {
    layout,
  };
}
